<div class="header-container">
  <button mat-stroked-button class="new-ticket-button" (click)="openCreateTicket()">
    {{ 'INBOX.TICKETS.CREATE' | translate }}
  </button>
</div>
<div class="section-ticket"></div>
<section>
  <inbox-ticket-list
    class="ticket-list"
    [partner]="partnerAccountGroupId$ | async"
    [title]="'INBOX.TICKETS.OPEN_TITLE' | translate"
    [status]="'open'"
  ></inbox-ticket-list>
</section>
<div class="section-ticket"></div>
<section>
  <inbox-ticket-list
    class="ticket-list"
    [partner]="partnerAccountGroupId$ | async"
    [title]="'INBOX.TICKETS.CLOSED_TITLE' | translate"
    [status]="'closed'"
  ></inbox-ticket-list>
</section>
